// extracted by mini-css-extract-plugin
module.exports = {"light":"_3vq_o","dark":"_2tiCT"};